import { INotification } from 'services/notifications/types'

type Translations = Record<string, string | undefined> | null | undefined

const EVENT_TITLE_TRANSLATION_KEYS: Record<string, string> = {
  post_created: 'created_a_new_post{suffix}',
  post_ping: 'sent_you_a_reminder_of_a_post{suffix}',
  post_activity_counter: 'post_like_counter_notification{suffix} / post_view_counter_notification{suffix}',
  task_start: 'new_task_has_been_updated',
  task_deadline_passed: 'end_task_reminder',
  task_deadline_day_before: 'uncompleted_task',
  task_deadline_one_hour_before: 'one_hour_left_to_complete_the_task',
  task_result_approved: 'task_has_been_approved',
  task_result_disapproved: 'result_has_been_disapproved',
  task_result_ai_feedback: 'ai_task_feedback',
  task_ping: 'uncompleted_task',
  campaign_created: 'new_campaign_has_been_created',
  comment_on_subtask_creator: 'commented_on_your_sub-task_v2',
  comment_on_subtask_team_members: 'commented_on_your_team_members_sub-task_v2',
  comment_on_subtask_group_members: 'commented_on_sub-task_v2',
  comment_on_media: 'commented_on_sub-task_v2',
  media_comment_reply: 'replied_to_your_comment_v2',
  comment_on_result: 'commented_on_sub-task_v2',
  result_comment_reply: 'replied_to_your_comment_v2',
  comment_on_task_result_context: 'commented_on_sub-task_v2',
  task_result_context_comment_reply: 'replied_to_your_comment_v2',
  service_call_created: 'new_service_call_has_been_created',
  service_call_updated: 'service_call_has_been_updated',
  service_call_assigned: 'service_call_has_been_assigned',
}

const RAW_KEY_MARKERS = ['raw', 'caller-supplied']

const isTechnicalTitle = (title: string): boolean => /[_-]/.test(title) && title === title.toLowerCase()

const getTranslation = (translations: Translations, key?: string | null): string | undefined => {
  if (!key) return undefined
  const normalizedKey = key.trim()
  if (!normalizedKey) return undefined
  return translations?.[normalizedKey]
}

const getTitleTranslationKey = (notification: INotification): string | undefined => {
  const data = notification.data ?? {}
  return (
    notification.title_translation_key ??
    data.title_translation_key ??
    notification.titleTranslationKey ??
    data.titleTranslationKey ??
    data.title_key ??
    EVENT_TITLE_TRANSLATION_KEYS[notification.event_type]
  )
}

const getCandidateTranslationKeys = (notification: INotification): string[] => {
  const keys = [getTitleTranslationKey(notification), notification.title].filter(Boolean) as string[]

  return keys
    .flatMap((key) => key.split('/'))
    .map((key) => key.trim())
    .filter((key) => key && !RAW_KEY_MARKERS.some((marker) => key.toLowerCase().includes(marker)))
    .filter((key) => !key.includes('{'))
}

export const resolveNotificationTitle = (
  notification: INotification,
  translations: Translations,
  fallbackTitle: string
): string => {
  const translatedTitle = getCandidateTranslationKeys(notification)
    .map((key) => getTranslation(translations, key))
    .find(Boolean)

  if (translatedTitle) return translatedTitle

  const title = notification.title?.trim()
  if (!title) return fallbackTitle
  if (isTechnicalTitle(title)) return fallbackTitle

  return title
}
